import { CurecallCopyButton, CurecallTooltip, ECurecallSize, RoundInfoIcon } from '@honestica/curecall-ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TPatient } from 'src/types/patient'
import { LifenPatientSearchModal } from './lifen-patient-search-modal.component'

type TLifenPatientRefItemProps = {
  patient: TPatient
  projectId: number
}

export const LifenPatientRefItem = ({ patient, projectId }: TLifenPatientRefItemProps) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!patient.lifenPatientRef && !patient.remoteId) return null

  return (
    <>
      {patient.lifenPatientRef && (
        <CurecallTooltip
          tooltipPosition="bottom-start"
          content={`${t('common.actions.copy')} : ${t('common.patient.lifen-id')}`}
        >
          <CurecallCopyButton
            ariaLabelText={t('common.patient.lifen-id')}
            data={`Patient/${patient.lifenPatientRef}`}
            size={ECurecallSize.MEDIUM}
            className="tw-w-max tw-mr-2 tw-h-8"
          />
        </CurecallTooltip>
      )}
      <span className="c-mr-2">
        {patient.lifenPatientRef
          ? `${t('common.patient.lifen-id')} : Patient/${patient.lifenPatientRef}`
          : t('common.patient.lifen-id')}
      </span>
      <CurecallTooltip tooltipPosition="bottom" content={t('common.patient.lifen-id-test-tooltip')}>
        <div onClick={() => setIsModalOpen(true)} className="c-cursor-pointer">
          <RoundInfoIcon className="c-text-blue-500 c-h-4" />
        </div>
      </CurecallTooltip>

      {isModalOpen && patient.remoteId && (
        <LifenPatientSearchModal
          projectId={projectId}
          remoteId={patient.remoteId}
          isOpen={isModalOpen}
          onToggle={() => setIsModalOpen(false)}
          hasPersistedLifenPatientRef={!!patient.lifenPatientRef}
        />
      )}
    </>
  )
}
